const einDashboard = {
  einDashboard: {
    installingSince: 'Instalowanie systemów Enphase od',
    accountManager: 'Menedżer kont Enphase',
    installationShare: 'Udział instalacji Enphase',
    nps: 'Poziom zadowolenia klientów (NPS)',
    viewDashboard: 'Wyświetl pulpit',
    quarterInfo: 'na kw. %{quarter}, %{year} r. (użytek domowy)',
    npsTooltip:
      'Poziom zadowolenia klientów (Net Promoter Score, NPS) to indeks wartości od −100 do 100, który mierzy chęć klientów do polecania produktów lub usług firmy. Wynik ten jest oparty na ocenach wystawionych przez Twoich klientów w aplikacji mobilnej Enlighten dotyczących Twoich usług i jest widoczny tylko dla Ciebie i firmy Enphase. Domyślny okres danych to ostatnie 13 miesięcy.',
    activity: 'Aktywność',
    sites: 'Lokalizacje z instalacjami fotowoltaicznymi',
    batteries: 'Akumulatory',
    acb: 'Akumulatory AC',
    certifications: 'Certyfikaty',
    community: 'Społeczność',
    storage: 'Lokalizacje z systemami magazynowania energii',
    lastInstalledLabel: 'zainstalowane w ciągu ostatnich 12 miesięcy',
    lastCommissionedLabel: 'oddane w ciągu ostatnich 12 miesięcy',
    viewDetails: 'Wyświetl szczegóły',
    seeReviews: 'Wyświetl opinie',
    viewCommunity: 'Wyświetl społeczność',
    certificateLabel: 'Ukończone certyfikacje: %{count}/%{totalCount}',
    networkLabel: {
      one: '%{count} post, ostatni post z dn. %{postDate}',
      other: '%{count} posty(-ów), ostatni post z dn. %{postDate}'
    },
    requestProductAccess: 'Wyślij prośbę o przyznanie dostępu do produktu',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: 'Pomoc w uzyskaniu zezwolenia',
    sgip: 'Pomoc SGIP',
    learnMore: 'Więcej informacji',
    aboutProduct: 'o produkcie',
    betaReleaseDate: 'Data wprowadzenia wersji beta',
    requestEarlyAccess: 'Wyślij prośbę o przyznanie wczesnego dostępu',
    viewAllProduct: 'Wyświetl wszystkie produkty',
    signUp: 'Zarejestruj się',
    betaReleaseLabel: 'do wszystkich nowych wersji produktów beta',
    financing: 'Wsparcie finansowe',
    digitalPlatform: 'Platforma cyfrowa',
    lpp: 'LPP',
    requestedText: 'Wysłano prośbę o przyznanie wczesnego dostępu',
    grantedText: 'Przyznano dostęp do wersji beta',
    products: 'Produkty',
    ratingsReviews: 'Oceny i opinie',
    reviews: 'Opinie',
    otherReviews: 'Inne opinie',
    updateDetails: 'Szczegóły aktualizacji',
    totalSavings: 'Oszczędności całkowite',
    inLastYear: 'W ciągu 12 ostatnich miesięcy',
    viewBreakdown: 'Zobacz szczegóły',
    leadsReceived: 'Otrzymane dane potencjalnych klientów',
    leadsClosure: 'Zamknięte sprawy potencjalnych klientów',
    leadsWon: 'Pozyskani potencjalni klienci',
    creditAvailable: 'Dostępny kredyt',
    buyMore: 'Kup więcej',
    messageFromCeo: 'Wiadomość od naszego dyrektora zarządzającego',
    communityUpdates: 'Powiadomienia dotyczące społeczności',
    makeAppointments: 'Umawianie spotkań',
    applicableText: 'Dotyczy tylko członków na poziomie platynowym',
    view: 'Widok',
    downloadAll: 'Pobierz wszystko',
    promoteText: 'Promuj swoją firmę za pomocą odznak i logotypów',
    asOfText: 'Na dzień %{date}',
    yearTotal: 'Łącznie/rok',
    redeemed: 'Zrealizowano',
    laborProtectionPlan: 'Program ochrony pracy',
    acmPromotion: 'Promocja ACM',
    save: {
      lre_data: 'Oszczędności od LPP',
      permit_data: 'Oszczędności z zezwolenia',
      financing_data: 'Oszczędności z finansowania',
      sgip_data: 'Oszczędności od SGIP',
      warrantyExtension: 'Oszczędności na przedłużeniu gwarancji'
    },
    platinumLogo: 'Logo platynowe',
    enphaseLogo: 'Logo Enphase',
    otherAssets: 'Inne zasoby',
    ensembleCertificate: 'Certyfikat Ensemble',
    salesCertificate: 'Certyfikat sprzedażowy 1.0',
    marketingCertificate: 'Certyfikat marketingowy 1.0',
    solarInstallCertificate: 'Certyfikat instalacji fotowoltaicznej',
    validTill: 'Ważność do %{date}',
    noDataAvailable: 'Brak dostępnych danych',
    notAvailable: 'Niedostępny',
    notApplicable: 'Nie dotyczy',
    title: 'Pulpit EIN',
    congratulationSignUp: 'Gratulacje! Teraz będziesz mieć wczesny dostęp do każdego nowego produktu/usługi Enphase',
    benefits: 'Korzyści',
    installationShareTooltip: 'Ta liczba wskazuje, jaki procent wszystkich Twoich instalacji to instalacje Enphase',
    dataFromThirdParty: '*Zgodnie z danymi ze źródła zewnętrznego',
    reviewsNotAvailable: 'Recenzje nie są dostępne',
    enphaseExecutive: 'Wykonawca Enphase',
    digitalAssets: 'Zasoby cyfrowe',
    leads: 'Potencjalni klienci',
    tierSavings: 'Oszczędności poziomu',
    exclusiveUpdates: 'Ekskluzywne aktualizacje',
    executiveSponsor: 'Inicjator z kierownictwa',
    merchandise: 'Towar',
    certifiedUsers: 'Certyfikowani użytkownicy',
    noteAllowedOnce: 'Uwaga: powyższy link nie może być edytowany po utworzeniu',
    saveLink: 'Zapisz link',
    confirm: 'Potwierdź',
    copyLink: 'Skopiuj link',
    allowedCharactersError: 'Dozwolone są tylko litery, cyfry, łącznik i podkreślenie (maks. 500 znaków)',
    createSystemEstimatorLink:
      'Stwórz spersonalizowany link do narzędzia do oceny kosztów systemu i udostępnij go swoim klientom, aby uzyskać od nich potencjalnych klientów. Każdy potencjalny klient wygenerowany z tego linku zostanie udostępniony tylko Tobie w Twoim Enlighten Managerze.',
    shareSystemEstimatorLink:
      'Udostępnij spersonalizowany link do narzędzia do oceny kosztów systemu swoim klientom, aby uzyskać od nich potencjalnych klientów. Każdy potencjalny klient wygenerowany z tego linku zostanie udostępniony tylko Tobie w Twoim Enlighten Managerze.',
    systemEstimatorLink: 'Link do narzędzia do oceny kosztów systemu',
    confirmChanges: 'Zatwierdź zmiany',
    confirmSELink:
      'Zatwierdź łącze do narzędzia do oceny kosztów systemu. Po zapisaniu tego linku nie będzie można edytować.',
    copied: 'Skopiowano',
    mySELink: 'Mój link do narzędzia do oceny kosztów systemu',
    sdtUrlExistsError: 'Ten link jest już używany przez innego instalatora. Wybierz inny link',
    all: 'Wszystkie',
    filterText: 'Filtruj',
    noProductAvailable: 'Brak dostępnych produktów'
  }
};

export default einDashboard;
